// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"844":"299e79ba93bf7846","895":"bde01f7d76df312a","6321":"320f97746af4b110"}[chunkId] + ".css";
};